import PriceListPicker from "emun.salesrep/territory-manager/repgroup/pricelist-picker";
import RepGroupPicker from "emun.vendor/picker/repgroup-picker";
import ShipMethodPicker from "emun.vendor/picker/shipmethod-picker";
import TermPicker from "emun.vendor/picker/term-picker";
import VendorGroupPicker from "emun.vendor/picker/vendorgroup-picker";
import prompt from "emun.vendor/vendor-edit";
import vendorConfig from "emun.vendor/vendor.config";
import AutoQuery from "servicestack/auto-query/auto-query.es6";
import basicController from "servicestack/basic.controller.properties";
import $appConfig from "servicestack/config";
import ServiceBus from "servicestack/service-bus";
import modals from "webmodals/modals";
import DivisionPicker from 'emun.salesrep/territory-manager/division/picker/division-picker'
import VendorPicker from 'emun.vendor/picker/vendor-picker'

export default class VendorDashboardController {
  constructor() {
    basicController(this);
    let $ctrl = this;
    $ctrl.bus = new ServiceBus();
    $ctrl.vendorConfig = vendorConfig;
    $ctrl.chartLoaded = false;
    $ctrl.productImage = $appConfig.productImage.bind($appConfig);
    if ($ctrl.$session.vendorGroup) {
      $ctrl.vendorList = new AutoQuery({
        url: "QueryVendorList.json?VendorGroup=" + $ctrl.$session.vendorGroup,
        autoLoad: true,
        onLoaded: function (args) {
          $ctrl.vendorId = "All";
        },
      });
    }
    let options = {
      url:
        "QueryVendors.json?IncludeInactive=true&IncludeSalesData=true&Id=" +
        $ctrl.vendorId,
      pageSize: 15,
      orderBy: "Label",
      autoLoad: true,
      append: false,
      onLoaded: function (args) {
        $ctrl.vendor = args.first;
        if ($ctrl.vendor.settings.filter( s=> s.key == "OrderFormat").length) $ctrl.orderFormat = $ctrl.vendor.settings.filter( s=> s.key == "OrderFormat")[0].value;
        if ($ctrl.vendor.settings.filter( s=> s.key == "Gateway").length) $ctrl.creditcardGateway = $ctrl.vendor.settings.filter( s=> s.key == "Gateway")[0].value;
        $ctrl.$state.current.customTitle = $ctrl.vendor.label;
        $ctrl.submissionId = $ctrl.vendor.tags.EditForm;
        if ($ctrl.submissionId) {
          $ctrl.bus
            .send(`QueryFormSubmissions/${$ctrl.submissionId}.json`)
            .then(({ data }) => {
              if (data.results.length) {
                $ctrl.submission = {
                  label: "vendor-edit",
                  data: data.results[0].data,
                };
                $ctrl.vendor.meta = Object.assign(
                  {},
                  $ctrl.vendor.meta,
                  data.results[0].data
                );
              }
            });
        }
        if (!$ctrl.submissionId && !$ctrl.vendor.vendorName) $ctrl.edit();
        $ctrl.getSecret();
      },
    };
    $ctrl.query = new AutoQuery(options);
    //$ctrl.vendorFilter = $ctrl.$session.vendorGroup ? "GroupBy=VendorGroup&VendorGroup=" + $ctrl.$session.vendorGroup : "GroupBy=VendorID&vendorId=" + $ctrl.vendorId;
    $ctrl.dailySalesQuery = new AutoQuery({
      url: "QuerySalesYOYTotals.json?Sum=TotalSalesToday,TotalSalesCountToday,TotalSalesYesterday,TotalSalesCountYesterday,TotalSalesWeekToDate,TotalSalesCountWeekToDate,TotalSalesQuarterToDate,TotalSalesCountQuarterToDate,TotalSalesQuarterToDateLastYear,TotalSalesCountQuarterToDateLastYear,TotalSalesYearToDate,TotalSalesCountYearToDate,TotalSalesYearToDateLastYear,TotalSalesCountYearToDateLastYear,TotalSalesMonthToDate,TotalSalesCountMonthToDate,TotalSalesMonthToDateLastYear,TotalSalesCountMonthToDateLastYear",
      criteria: {
        GroupBy: $ctrl.$session.vendorGroup ? "VendorGroup" : "VendorId",
        VendorId: $ctrl.$session.vendorGroup ? undefined : $ctrl.vendorId,
        VendorGroup: $ctrl.$session.vendorGroup
          ? $ctrl.$session.vendorGroup
          : undefined,
      },
      autoLoad: true,
      pageSize: 1000,
      onLoaded: function (args) {
        $ctrl.dailySales = {
          total: 0,
          count: 0,
        };
        $ctrl.yesterdaySales = {
          total: 0,
          count: 0,
        };
        $ctrl.weekSales = {
          total: 0,
          count: 0,
        };
        $ctrl.quarterSales = {
          total: 0,
          count: 0,
        };
        $ctrl.lastquarterSales = {
          total: 0,
          count: 0,
        };
        $ctrl.ytdSales = {
          total: 0,
          count: 0,
        };
        $ctrl.lastytdSales = {
          total: 0,
          count: 0,
        };
        $ctrl.monthSales = {
          total: 0,
          count: 0,
        };
        $ctrl.mtdSales = {
          total: 0,
          count: 0,
        };
        $ctrl.lastmtdSales = {
          total: 0,
          count: 0,
        };
        if (args.total > 0) {
          var res = args.first;
          $ctrl.dailySales.total = res.sumTotalSalesToday;
          $ctrl.dailySales.count = res.sumTotalSalesCountToday;
          $ctrl.yesterdaySales.total = res.sumTotalSalesYesterday;
          $ctrl.yesterdaySales.count = res.sumTotalSalesCountYesterday;
          $ctrl.weekSales.total = res.sumTotalSalesWeekToDate;
          $ctrl.weekSales.count = res.sumTotalSalesCountWeekToDate;
          $ctrl.quarterSales.total += res.sumTotalSalesQuarterToDate;
          $ctrl.quarterSales.count += res.sumTotalSalesCountQuarterToDate;
          $ctrl.lastquarterSales.total +=
            res.sumTotalSalesQuarterToDateLastYear;
          $ctrl.lastquarterSales.count +=
            res.sumTotalSalesCountQuarterToDateLastYear;
          var percent = Math.round(
            ($ctrl.quarterSales.total / $ctrl.lastquarterSales.total) * 100
          );
          if (percent < 100) {
            $ctrl.quarterSales.percent = 100 - percent;
            $ctrl.quarterSales.trend = "down";
          } else if (percent > 100) {
            $ctrl.quarterSales.percent = percent - 100;
            $ctrl.quarterSales.trend = "up";
          } else {
            $ctrl.quarterSales.percent = 100;
            $ctrl.quarterSales.trend = "neutral";
          }
          $ctrl.ytdSales.total += res.sumTotalSalesYearToDate;
          $ctrl.ytdSales.count += res.sumTotalSalesCountYearToDate;
          $ctrl.lastytdSales.total += res.sumTotalSalesYearToDateLastYear;
          $ctrl.lastytdSales.count += res.sumTotalSalesCountYearToDateLastYear;
          var percent = Math.round(
            ($ctrl.ytdSales.total / $ctrl.lastytdSales.total) * 100
          );
          if (percent < 100) {
            $ctrl.ytdSales.percent = 100 - percent;
            $ctrl.ytdSales.trend = "down";
          } else if (percent > 100) {
            $ctrl.ytdSales.percent = percent - 100;
            $ctrl.ytdSales.trend = "up";
          } else {
            $ctrl.ytdSales.percent = 100;
            $ctrl.ytdSales.trend = "neutral";
          }
          $ctrl.mtdSales.total += res.sumTotalSalesMonthToDate;
          $ctrl.mtdSales.count += res.sumTotalSalesCountMonthToDate;
          $ctrl.lastmtdSales.total += res.sumTotalSalesMonthToDateLastYear;
          $ctrl.lastmtdSales.count += res.sumTotalSalesCountMonthToDateLastYear;
          var percent = Math.round(
            ($ctrl.mtdSales.total / $ctrl.lastmtdSales.total) * 100
          );
          if (percent < 100) {
            $ctrl.mtdSales.percent = 100 - percent;
            $ctrl.mtdSales.trend = "down";
          } else if (percent > 100) {
            $ctrl.mtdSales.percent = percent - 100;
            $ctrl.mtdSales.trend = "up";
          } else {
            $ctrl.mtdSales.percent = 100;
            $ctrl.mtdSales.trend = "neutral";
          }
        }
      },
    });
    $ctrl.lastweekSalesQuery = new AutoQuery({
      url: "QuerySalesDailyTotals.json?dateRange=LastWeek&Sum=OrderTotal&Count=OrderTotal",
      criteria: {
        GroupBy: $ctrl.$session.vendorGroup ? "VendorGroup" : "VendorId",
        VendorId: $ctrl.$session.vendorGroup ? undefined : $ctrl.vendorId,
        VendorGroup: $ctrl.$session.vendorGroup
          ? $ctrl.$session.vendorGroup
          : undefined,
      },
      autoLoad: true,
      pageSize: 1000,
      onLoaded: function (args) {
        $ctrl.lastweekSales = {
          total: 0,
          count: 0,
        };
        if (args.total > 0) {
          $ctrl.lastweekSales.total = Math.round(args.first.sumOrderTotal);
          $ctrl.lastweekSales.count = args.first.countOrderTotal;
        }
      },
    });
    $ctrl.openOrders = new AutoQuery({
      url: "QueryCarts.json?StatusNotEqualTo=Cart&vendorId=" + $ctrl.vendorId,
      orderBy: "-OrderedOn",
      autoLoad: true,
      pageSize: 10,
    });
    $ctrl.showCodes = [];
    $ctrl.showCodesQuery = new AutoQuery({
      url: "QueryMarketDates.json",
      autoLoad: true,
      take: 1000,
      onLoaded: function (args) {
        args.results.forEach(function (market) {
          if ($ctrl.showCodes.indexOf(market.showCode) == -1) {
            $ctrl.showCodes.push(market.showCode);
          }
        });
      },
    });
    $ctrl.goalsQuery = new AutoQuery({
      url: "QuerySalesRepGoals.json?Sum=SalesGoalThisMonth,SalesGoalThisYear,SalesGoalLastYear,SalesGoalLastMonth,SalesGoalThisQuarter&GroupBy=SalesRepID",
      criteria: {
        VendorId: $ctrl.$session.vendorGroup ? undefined : $ctrl.vendorId,
        VendorGroup: $ctrl.$session.vendorGroup
          ? $ctrl.$session.vendorGroup
          : undefined,
      },
      autoLoad: true,
      pageSize: 1000,
      onLoaded: function (args) {
        $ctrl.goals = {
          month: 0,
          monthPercent: 0,
          quarter: 0,
          quarterPercent: 0,
          year: 0,
          yearPercent: 0,
        };
        if (args.total > 0) {
          args.results.forEach(function (res) {
            $ctrl.goals.month += res.sumSalesGoalThisMonth;
            $ctrl.goals.quarter += res.sumSalesGoalThisQuarter;
            $ctrl.goals.year += res.sumSalesGoalThisYear;
          });
          $ctrl.goals.monthPercent = Math.round(
            ($ctrl.mtdSales.total / $ctrl.goals.month) * 100
          );
          $ctrl.goals.quarterPercent = Math.round(
            ($ctrl.quarterSales.total / $ctrl.goals.quarter) * 100
          );
          $ctrl.goals.yearPercent = Math.round(
            ($ctrl.ytdSales.total / $ctrl.goals.year) * 100
          );
        }
      },
    });
    $ctrl.vendorGroupsQuery = new AutoQuery({
      url: "QueryVendorGroupList.json",
      criteria: {
        VendorId: $ctrl.vendorId,
      },
      autoLoad: true,
      hideLeftNav: true,
    });
    $ctrl.repGroupsQuery = new AutoQuery({
      url: "QueryRepGroups.json",
      criteria: {
        VendorId: $ctrl.vendorId,
      },
      autoLoad: true,
      hideLeftNav: true,
    });
    $ctrl.termsQuery = new AutoQuery({
      url: "QueryVendorTerms.json",
      criteria: {
        VendorId: $ctrl.vendorId,
      },
      autoLoad: true,
      hideLeftNav: true,
    });
    $ctrl.shipMethodsQuery = new AutoQuery({
      url: "QueryVendorShipMethods.json",
      criteria: {
        VendorId: $ctrl.vendorId,
      },
      autoLoad: true,
      hideLeftNav: true,
    });
    $ctrl.priceListsQuery = new AutoQuery({
      url: "QueryVendorPriceLists.json",
      criteria: {
        strVendorId: $ctrl.vendorId,
      },
      autoLoad: true,
      hideLeftNav: true,
    });
    $ctrl.divisionsQuery = new AutoQuery({
      url: "QueryDivisions.json",
      criteria: {
        VendorId: $ctrl.vendorId,
      },
      autoLoad: true,
      hideLeftNav: true,
    });
    $ctrl.$on("$vendorEditSubmitted", () => $ctrl.query.load(true));
  }

  getSecret() {
    const $ctrl = this;
    $ctrl.bus.send("AWS/GetSecret", {
      SecretName: "SFTP/" + $ctrl.vendor.id
    }).then(function(response) {
      if (response.data.secretString) $ctrl.secretData = JSON.parse(response.data.secretString);
    });
  }
  createSecret() {
    const $ctrl = this;
    $ctrl.bus.send("AWS/CreateSecret", {
      SecretName: `SFTP/${$ctrl.vendor.id}`,
      SecretDescription: `V:${$ctrl.vendor.label}`
    }).then(function(res) {
      if (res.data.arn) {
        $ctrl.getSecret();
      }
    });
  }
  load() {
    return $ctrl.query.load.apply($ctrl.query, arguments);
  }
  runReport(name) {
    const $ctrl = this;
    var filter = $ctrl.$session.vendorGroup
      ? "?VendorGroup=" + $ctrl.$session.vendorGroup
      : "?VendorId=" + $ctrl.vendorId;
    let url = $ctrl.$appConfig.resolveServiceUrl(name + filter);
    return (location.href = url);
  }
  edit() {
    const $ctrl = this;
    return prompt
      .open({
        title: $ctrl.vendor.id + " - " + $ctrl.vendor.vendorName + " Edit...",
        vendor: $ctrl.vendor,
      })
      .then(function () {
        $ctrl.query.load(true);
      });
  }
  delete() {
    const $ctrl = this;
    return modals
      .confirm(
        "Are you sure you want to delete vendor " +
          $ctrl.vendor.vendorName +
          "?",
        "Delete Vendor"
      )
      .result.then(function () {
        $ctrl.bus.send("DeleteVendor.json", { id: $ctrl.vendor.id }).then(
          function (response) {
            $ctrl.$state.go("vendor.list", {});
          },
          function (response) {
            if (response.data.responseStatus.errorCode)
              modals.alert(response.data.responseStatus.message);
          }
        );
      });
  }
  selectVendorGroups() {
    let $ctrl = this;
    $ctrl.vendorGroups = [];

    return VendorGroupPicker({
      title: "Select Vendor Group(s)...",
      subTitle: "",
      applyTagsButtonText: false,
      single: false,
      viewSelections: false,
    }).then((result) => {
      $ctrl.bus
        .send("AddVendorGroups", {
          VendorId: $ctrl.vendor.id,
          VendorGroups: result,
        })
        .then(function (response) {
          $ctrl.vendorGroupsQuery.load();
        });
    });
  }
  selectRepGroups() {
    let $ctrl = this;
    $ctrl.vendorGroups = [];

    return RepGroupPicker({
      title: "Select Rep Group(s)...",
      subTitle: "",
      applyTagsButtonText: false,
      single: false,
      viewSelections: false,
    }).then((result) => {
      $ctrl.bus
        .send("AddVendorRepGroups", {
          VendorId: $ctrl.vendor.id,
          RepGroups: result,
        })
        .then(function (response) {
          $ctrl.repGroupsQuery.load();
        });
    });
  }
  removeRepGroup(group) {
    let $ctrl = this;
    return modals
      .confirm(
        "Are you sure you want to remove " + group.name,
        "Remove Rep Group?"
      )
      .result.then(function () {
        $ctrl.bus
          .send("DeleteVendorRepGroup", {
            VendorId: $ctrl.vendor.id,
            RepGroup: group.name,
          })
          .then((result) => {
            $ctrl.repGroupsQuery.load();
          });
      });
  }
  removeVendorGroup(group) {
    let $ctrl = this;
    return modals
      .confirm(
        "Are you sure you want to remove " + group.groupName,
        "Remove Vendor Group?"
      )
      .result.then(function () {
        $ctrl.bus
          .send("DeleteVendorGroup", {
            VendorId: $ctrl.vendor.id,
            VendorGroup: group.groupName,
          })
          .then((result) => {
            $ctrl.vendorGroupsQuery.load();
          });
      });
  }

  addVendorShipMethod() {
    let $ctrl = this;
    $ctrl.shipmethods = [];

    return ShipMethodPicker({
      title: "Select Ship Method(s)...",
      subTitle: "",
      applyTagsButtonText: false,
      single: false,
      viewSelections: false,
    }).then((result) => {
      $ctrl.bus
        .send("AddVendorShipMethods", {
          VendorId: $ctrl.vendor.id,
          ShipMethods: result,
        })
        .then(function (response) {
          $ctrl.shipMethodsQuery.load();
        });
    });
  }
  updateVendorShipMethod(vs) {
    const $ctrl = this;
    $ctrl.bus
      .send("UpdateVendorShipMethod.json", vt)
      .then(function () {
        return $ctrl.vendors.load(true);
      })
      .catch();
  }
  deleteVendorShipMethod(vs) {
    let $ctrl = this;
    return modals
      .confirm(
        "Are you sure you want to remove " + vs.shipMethod.name,
        "Remove Vendor Ship Method?"
      )
      .result.then(function () {
        $ctrl.bus
          .send("DeleteVendorShipMethod", {
            VendorId: $ctrl.vendor.id,
            ShipMethodId: vs.shipMethod.id,
          })
          .then((result) => {
            $ctrl.shipMethodsQuery.load();
          });
      });
  }

  addVendorPriceList() {
    let $ctrl = this;
    $ctrl.pricelists = [];

    return PriceListPicker({
      title: "Select Price List(s)...",
      subTitle: "",
      applyTagsButtonText: false,
      single: false,
      viewSelections: false,
    }).then((result) => {
      $ctrl.bus
        .send("AddVendorPriceLists", {
          VendorId: $ctrl.vendor.id,
          PriceLists: result,
        })
        .then(function (response) {
          $ctrl.priceListsQuery.load();
        });
    });
  }

  deleteVendorPriceList(pl) {
    let $ctrl = this;
    return modals
      .confirm(
        "Are you sure you want to remove " + pl.strPriceList,
        "Remove Vendor Price List?"
      )
      .result.then(function () {
        $ctrl.bus
          .send("DeleteVendorPriceList", {
            VendorId: $ctrl.vendor.id,
            PriceList: pl.strPriceList,
          })
          .then((result) => {
            $ctrl.priceListsQuery.load();
          });
      });
  }

  addVendorTerm() {
    let $ctrl = this;
    $ctrl.terms = [];

    return TermPicker({
      title: "Select Term(s)...",
      subTitle: "",
      applyTagsButtonText: false,
      single: false,
      viewSelections: false,
    }).then((result) => {
      $ctrl.bus
        .send("AddVendorTerms", {
          VendorId: $ctrl.vendor.id,
          Terms: result,
        })
        .then(function (response) {
          $ctrl.termsQuery.load();
        });
    });
  }
  updateVendorTerm(vt) {
    const $ctrl = this;
    $ctrl.bus
      .send("UpdateVendorTerm.json", vt)
      .then(function () {
        return $ctrl.vendors.load(true);
      })
      .catch();
  }
  deleteVendorTerm(vt) {
    let $ctrl = this;
    return modals
      .confirm(
        "Are you sure you want to remove " + vt.term.name,
        "Remove Vendor Term?"
      )
      .result.then(function () {
        $ctrl.bus
          .send("DeleteVendorTerm", {
            VendorId: $ctrl.vendor.id,
            TermId: vt.term.id,
          })
          .then((result) => {
            $ctrl.termsQuery.load();
          });
      });
  }
	addDivision() {
		let $ctrl = this;
		$ctrl.divisionIds = [];

		return DivisionPicker({
			title: "Select Divisions...",
			subTitle: "",
			applyTagsButtonText: false,
			single: false,
			viewSelections: false,
		}).then((result) => {
				$ctrl.bus.send("AddVendorDivisions", {
					VendorId: $ctrl.vendorId,
					DivisionIds: result
				}).then(function (response) {
					$ctrl.divisionsQuery.load();
				});
		});
	}
  copyDivisions() {
    const $ctrl = this;
		$ctrl.vendorIds = [];

      return VendorPicker({
        title: "Select Vendor(s)...",
        subTitle: "",
        applyTagsButtonText: false,
        single: true,
        viewSelections: false, 
      }).then((result) => {
        modals.confirm("Please confirm you want to continue.  This will erase divisions from " + $ctrl.vendor.label + " and copy the divisions from " + result.label, "Copy divisions").result.then(function() {
          $ctrl.bus.send("CopyVendorDivisions", {
            SourceVendorId: result.id,
            DestinationVendorId: $ctrl.vendorId
          }).then(function (response) {
            $ctrl.divisionsQuery.load();
          });
        });
      });  

  }
  copyHardcodes() {
    const $ctrl = this;
		$ctrl.vendorIds = [];

      return VendorPicker({
        title: "Select Vendor(s)...",
        subTitle: "",
        applyTagsButtonText: false,
        single: true,
        viewSelections: false, 
      }).then((result) => {
        modals.confirm("Please confirm you want to continue.  This will erase hard codes from " + $ctrl.vendor.label + " and copy the hard codes from " + result.label, "Copy Hard Codes").result.then(function() {
          $ctrl.bus.send("CopyVendorHardcodes", {
            SourceVendorId: result.id,
            DestinationVendorId: $ctrl.vendorId
          }).then(function (response) {
            //$ctrl.divisionsQuery.load();
          });
        });
      });  

  }
	deleteDivision(division) {
		const $ctrl = this;
		return modals
			.confirm("Are you sure you want to remove " + division.name, "Remove Division?")
			.result.then(function () {
				//console.info("delete it");
				$ctrl.bus
					.send("DeleteDivisionVendor.json", {
						DivisionId: division.id,
						VendorId: $ctrl.vendorId
					})
					.then(function () {
						return $ctrl.divisionsQuery.load(true);
					})
					.catch(

					);
			});
	}
  setVendor() {
    const $ctrl = this;
    if ($ctrl.vendorId == "All") {
      $ctrl.dailySalesQuery.criteria = {
        GroupBy: "VendorGroup",
        VendorGroup: $ctrl.$session.vendorGroup,
      };
      $ctrl.lastweekSalesQuery.criteria = {
        GroupBy: "VendorGroup",
        VendorGroup: $ctrl.$session.vendorGroup,
      };
      $ctrl.goalsQuery.criteria = {
        VendorGroup: $ctrl.$session.vendorGroup,
      };
    } else {
      $ctrl.dailySalesQuery.criteria = {
        GroupBy: "VendorId",
        VendorId: $ctrl.vendorId,
      };
      $ctrl.lastweekSalesQuery.criteria = {
        GroupBy: "VendorId",
        VendorId: $ctrl.vendorId,
      };
      $ctrl.goalsQuery.criteria = {
        VendorId: $ctrl.vendorId,
      };
    }
    $ctrl.dailySalesQuery.load();
    $ctrl.lastweekSalesQuery.load();
    $ctrl.goalsQuery.load();
  }
}
